import React from 'react'
import PropTypes from 'prop-types'

import { sendHoverSoundCommand, sendClickSoundCommand } from '../../helpers/web_to_client'

import styles from './Counter.css'

const propTypes = {
    total: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    tooltipId: PropTypes.string,
    buttonTooltipId: PropTypes.string,
}

class Counter extends React.PureComponent {
    constructor(props) {
        super(props)

        this.handleClick = this.handleClick.bind(this)
    }

    handleClick() {
        this.props.onClick()
    }

    render() {
        const dataAttrs = this.props.tooltipId ? {
            'data-tip': true,
            'data-for': this.props.tooltipId,
        } : {}

        const buttonDataAttrs = this.props.buttonTooltipId ? {
            'data-tip': true,
            'data-for': this.props.buttonTooltipId,
        } : {}

        return (
            <div className={styles.base}>
                <span {...dataAttrs}>
                    <span className={styles.current}>{this.props.current}</span>
                    <span className={styles.divider}>/</span>
                    <span className={styles.total}>{this.props.total}</span>
                </span>
                <button
                    className={styles.reset}
                    onClick={this.handleClick}
                    onMouseDown={sendClickSoundCommand}
                    onMouseEnter={sendHoverSoundCommand}
                    {...buttonDataAttrs}
                >
                    <div className={styles.icon} />
                </button>
            </div>
        )
    }
}

Counter.propTypes = propTypes

export default Counter



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/Counter/Counter.jsx